'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnimatedInput = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(AnimatedInput, _React$PureComponent);

    function AnimatedInput() {
        (0, _classCallCheck3.default)(this, AnimatedInput);
        return (0, _possibleConstructorReturn3.default)(this, (AnimatedInput.__proto__ || (0, _getPrototypeOf2.default)(AnimatedInput)).apply(this, arguments));
    }

    (0, _createClass3.default)(AnimatedInput, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                type = _props.type,
                className = _props.className,
                value = _props.value,
                rest = (0, _objectWithoutProperties3.default)(_props, ['type', 'className', 'value']);


            var filled = !!value;
            var classes = (className || '') + ' input--init';
            if (value) {
                classes += ' input--filled';
            }
            return _react2.default.createElement('input', (0, _extends3.default)({ type: type || 'text', className: classes, value: value || '' }, rest));
        }
    }]);
    return AnimatedInput;
}(_react2.default.PureComponent), _class.propTypes = {
    id: _propTypes2.default.string,
    name: _propTypes2.default.string,
    value: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func,
    onKeyPress: _propTypes2.default.func,
    className: _propTypes2.default.string,
    type: _propTypes2.default.string
}, _temp);
exports.default = AnimatedInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/AnimatedInput.js
// module id = 743
// module chunks = 0